import { fromJS } from 'immutable';
import _ from 'lodash';

import {
  FETCH_TASK_SUCCESS,
  FETCH_TASK_FAILED,
  ASSIGN_RESOURCES_TO_TASKS,
  UPLOAD_TASKS_SUCCESS,
} from '../actions/tasks';
import { fetchTasksRoutine, saveJobRoutine, editTaskRoutine, removeTasksRoutine } from '../routines';
import { updateOrAddMap } from './helper';
import { toMap } from '../utils/helper';

const initialState = fromJS({
  tasks: {},
  task: {},
  loading: false,
  selectedTasks: [],
});

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchTasksRoutine.TRIGGER:
      return state.set('loading', true);
    case fetchTasksRoutine.SUCCESS:
      return state.set('tasks', fromJS(action.payload.tasks)).set('loading', false);
    case fetchTasksRoutine.FAILURE:
      return state.set('error', action.error).set('loading', false);
    case FETCH_TASK_SUCCESS:
      return state.set('task', fromJS(action.task)).set('loading', false);
    case FETCH_TASK_FAILED:
      return state.set('error', action.error).set('loading', false);
    case UPLOAD_TASKS_SUCCESS:
      return state.updateIn(['tasks'], (tasks) => tasks.merge(fromJS(toMap(action.tasks))));
    case ASSIGN_RESOURCES_TO_TASKS:
      const assignments = action.tasks.reduce((res, task) => _.assign(res, {
        [task.id]: {
          stages: action.stages,
          changed: true,
        },
      }), {});

      return state.mergeDeepIn(['tasks'], fromJS(assignments));
    case removeTasksRoutine.SUCCESS:
      const deletedTaskIds = action.payload.request.tasks.map((task) => task.id);
      return state.updateIn(['tasks'], (tasks) => {
        return tasks.filter((task, taskId) => !task.deleted && deletedTaskIds.indexOf(taskId) < 0);
      });
    case saveJobRoutine.SUCCESS:
      return state;
    case editTaskRoutine.SUCCESS:
      return state
        .updateIn(['tasks'], updateOrAddMap(fromJS(action.payload.task)))
        .set('task', fromJS(action.payload.task)).set('saving', false);
    case editTaskRoutine.FAILURE:
      return state.set('error', action.error).set('saving', false);
    case editTaskRoutine.FULFILL:
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/tasks.js